import { useI18n } from "providers/I18n"
import { useRevenueParams } from "../../hooks/useRevenueParams"
import { CustomHeader } from "./CustomHeader"
import React from "react"
import { Loading } from "components/Loading"
import { Box } from "@material-ui/core"

export type HeaderBoxType = {
  lastUpdated: string | undefined
  clientName?: string
  isLoading: boolean
  gcfLabel: string
  gcfView: boolean
}
export function HeaderBox({
  lastUpdated,
  clientName,
  isLoading,
  gcfLabel,
  gcfView,
}: HeaderBoxType) {
  const { t } = useI18n()
  const { clientParam, regionParam, marketParam, brandParam } =
    useRevenueParams()
  const [title, setTitle] = React.useState(t("revenue.revenuedashboard"))
  const [extraTitle, setExtraTitle] = React.useState("")

  const infos = React.useMemo(() => {
    if (clientParam && clientParam !== "All") {
      if (brandParam && brandParam !== "All") {
        setExtraTitle(`/ ${clientName}`)
        setTitle(brandParam)
        return
      }
      setTitle(clientName || clientParam)
    } else if (brandParam && brandParam !== "All") {
      setTitle(brandParam)
    } else if (marketParam && marketParam !== "All") {
      setTitle(marketParam)
    } else if (regionParam && regionParam !== "All") {
      setTitle(regionParam)
    } else if (gcfView) {
      setTitle(gcfLabel)
    } else {
      setTitle(t("revenue.revenuedashboard"))
    }
    setExtraTitle(" ")
    return title
  }, [
    clientParam,
    brandParam,
    marketParam,
    regionParam,
    gcfView,
    title,
    clientName,
    gcfLabel,
    t,
  ])

  if (isLoading) {
    return (
      <Box width="100%">
        <Loading />
      </Box>
    )
  }

  return (
    <CustomHeader
      title={infos ?? title}
      extraTitle={extraTitle}
      details={`${t("revenue.lastUpdated")}: ${lastUpdated}`}
    />
  )
}
